import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ModifyFIXOrderComponent from './ModifyFIXOrderComponent';
import * as tradeBookActions from './../../actions/tradeBookActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as activityActions from './../../actions/activityActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as reportActions from './../../actions/reportActions';
import * as authActions from '../../redux/modules/auth';
import * as commonActions from './../../actions/commonActions';
import styles from './../TradeBook/TradeBook.less';
import config from './../../config';
import Modal from 'react-modal';
import {ButtonToolbar, DropdownButton, MenuItem, Button} from 'react-bootstrap';
import { Card } from 'reactstrap';
import {Grid, DragDropProvider, Table, TableHeaderRow, TableColumnReordering, ColumnChooser,TableColumnVisibility, SearchPanel, Toolbar,TableSelection} from '@devexpress/dx-react-grid-bootstrap4';
import {SortingState, IntegratedSorting, SearchState, IntegratedFiltering,SelectionState,IntegratedSelection} from '@devexpress/dx-react-grid';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import numeral from 'numeral';
import { getCountofTableRows,setDirection,getSeparator, getAccountByCode, getInactiveAccounts, } from './../../utils/utils';
import { withStyles } from '@material-ui/core/styles';
import {Getter,Plugin} from '@devexpress/dx-react-core';
import moment from 'moment';
import appConstants from './../../appConstants';
import track from 'react-tracking';
import { displayInActiveAccMsg } from '../../utils/validation';

let separator;
let decimal;
let wsData;

// const elementsData = [
//   {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"dropdown-menu", "elementType":"normal", "applyTo":"all", "tagNames":"li"},
//   {"classNames":"form-control","elementType":"tag", "applyTo":"all", "tagNames":"input"},
//   {"classNames":"oi-eye","elementType":"tag", "applyTo":"all", "tagNames":"span"},
//   {"classNames":"lmtOrdDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"noDataColor", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"dx-g-bs4-table-container","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"widgetwrapper", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"dropdown-item", "elementType":"normal", "applyTo":"all", "tagNames":"button"}
// ];

const directionData=[
  {"classNames":"card-header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"widgetwrapper", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"refresh_icon", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"lmtOrderStatus", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"orderRowsCount", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"modalCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdbookText", "elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"btnText", "elementType":"normal", "applyTo":"all", "tagNames":"button"}
];

const getRowId = row => row;
let fixOrdRectFlag=false;
let selectedRowsToCancel = [];
import i18next from 'i18next';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
let compareRate = (a, b) => {
  let result;
  if (numeral(a)._value < numeral(b)._value) {
    result = -1;
  } else{
    result = 1;
  }
  return result;
};

const rowSelectionEnabled = row => row.status === "Outstanding";
class PatchedIntegratedSelection extends React.Component {
  render() {
    const { rowSelectionEnabled, ...restProps } = this.props;
    return (
      <Plugin>
        <Getter
          name="rows"
          computed={({ rows }) => {
            this.rows = rows;
            return rows.filter(rowSelectionEnabled);
          }}
        />
        <IntegratedSelection {...restProps} />
        <Getter
          name="rows"
          computed={() => this.rows}
        />
      </Plugin>
    )
  }
};

class PatchedTableSelection extends React.Component {
  render() {
    const { rowSelectionEnabled, ...restProps } = this.props;
    return (
      <TableSelection
        cellComponent={(props) => this.props.rowSelectionEnabled(props.tableRow.row) ?
          (
            <TableSelection.Cell {...props} />
          )
        :
          (
            <Table.StubCell {...props} />
          )
        }
        {...restProps}
      />
    );
  }
}

@connect(state => ({
  ACD: state.auth.ACD,
  fixingOrdBook:state.dashboardRoot.activityReducer.fixingOrdBook,
  fixModifyFlag:state.dashboardRoot.tradeBookReducer.fixModifyFlag,
  closeFIXModifypopup:state.dashboardRoot.tradeBookReducer.closeFIXModifypopup,
  ordersCTID:state.dashboardRoot.activityReducer.ordersCTID,
  userDetail:state.auth.userDetail,
  getAllOrdersTrd:state.dashboardRoot.tradeBookReducer.getAllOrdersTrd,
  fixOrdRandomNoDB:state.dashboardRoot.activityReducer.fixOrdRandomNoDB,
  fixOrdLoaderFlag:state.dashboardRoot.activityReducer.fixOrdLoaderFlag,
  actLogRandomNo:state.dashboardRoot.activityReducer.actLogRandomNo,
  fixingOrdMap:state.dashboardRoot.activityReducer.fixingOrdMap,
  status:state.dashboardRoot.instrumentListReducer.status,
  requestRejectModal:state.dashboardRoot.activityReducer.requestRejectModal,
  socketData:state.dashboardRoot.instrumentListReducer.socketData,
  tradeBookColumns:state.dashboardRoot.dashboardReducer.tradeBookColumns,
  language:state.dashboardRoot.commonReducer.language,
  selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  checkClickOnAddWidgetFlag:state.dashboardRoot.commonReducer.checkClickOnAddWidgetFlag,
  fontSize:state.auth.userDetail.fontSize,
  // allowLMT_PF:state.auth.allowLMT_PF,
  navigationStatus:state.dashboardRoot.commonReducer.navigationStatus,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  orderSelectionFlag:state.dashboardRoot.tradepanelReducer.orderSelectionFlag,
  statusChanged:state.dashboardRoot.activityReducer.statusChanged,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
}), {
  ...reportActions,...tradeBookActions,...dashboardActions,...activityActions,...tradepanelActions,...authActions,...commonActions,
})

@track(() => ({ widgetDetails: { tab: i18next.t('fixings') }}))

export default class FixingOrderTableComponent extends Component {
  static propTypes = {
    fixingOrdBook:PropTypes.array,
    userDetail:PropTypes.object,
    fixOrdLoaderFlag:PropTypes.bool,
    fixModifyFlag:PropTypes.bool,
    requestRejectModal:PropTypes.object,
    ordersCTID:PropTypes.array,
    handleCancelledFIX:PropTypes.func,
    handleFixingModal:PropTypes.func,
    fixOrdRefreshFlag:PropTypes.func,
    updateTrdBookCols:PropTypes.func,
    layoutChanged:PropTypes.func,
    tradeBookColumns:PropTypes.array,
    language:PropTypes.string,
    //allowLMT_PF:PropTypes.bool,
    navigationStatus:PropTypes.string,
    getInvoice:PropTypes.func,
    CloseIcon:PropTypes.object.isRequired,
    orderSelectionFlag:PropTypes.bool,
    orderSelectionFunc:PropTypes.func,
    statusChanged:PropTypes.array,
    validateOrder:PropTypes.func,
  };
  state = {
    fixOrdMap:null,
    selectFIX:'outstanding',
    selectFIXKey:"O",
    randomNo:0,
    outstngFixOrderRows:[],
    fixOrderFilledrows:[],
    fixCancelledOrderRows:[],
    allFixOrdersRows:[],
    fixAllOrderColumnOrder:[],
    fixAllOrderColumnOrderExtensions:[
      {columnName:'eventTime', width:170},
      {columnName:'status', width:100},
      {columnName:'orderNo', width:140},
      {columnName:'fixingDate', width:140},
      {columnName:'fixingEvent', width:170},
      {columnName:'deal', width:80},
      {columnName:'cmdtyPair', width:105},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:80},
      {columnName:'rate', width:100, align:'right'},
      {columnName:'docNo', width:140},
      {columnName:'placedBy', width:100},
      {columnName:'account', width:140},
      {columnName:'comments', width:140},
      {columnName:'action', width:23}
    ],
    fixAllOrderColumnOrderExtensionsAR:[
      {columnName:'eventTime', width:170},
      {columnName:'status', width:100},
      {columnName:'orderNo', width:140},
      {columnName:'fixingDate', width:140},
      {columnName:'fixingEvent', width:170},
      {columnName:'deal', width:80},
      {columnName:'cmdtyPair', width:105},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:80},
      {columnName:'rate', width:100, align:'right'},
      {columnName:'docNo', width:140},
      {columnName:'placedBy', width:100, align:'right'},
      {columnName:'account', width:140},
      {columnName:'comments', width:140},
      {columnName:'action', width:23}
    ],
    outFixOrdcolumns:[],
    outFixOrdColumnExtensions:[],
    outFixOrdColumnExtensionsAR:[],
    fixFilledOrderColumnOrder:[],
    fixFilledOrderColumnOrderExtensions:[
      { columnName:'eventTime', width:170},
      {columnName:'orderNo', width:130},
      { columnName:'fixingEvent', width:170},
      {columnName:'deal', width:80},
      {columnName:'cmdtyPair', width:115},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:84},
      {columnName:'rate', width:100, align:'right'},
      {columnName:'docNo', width:130},
      {columnName:'placedBy', width:100},
      {columnName:'filledBy', width:100},
      {columnName:'account', width:145},
      {columnName:'comments', width:100, align:'right'}
      ],
    fixFilledOrderColumnOrderExtensionsAR:[
      { columnName:'eventTime', width:170},
      {columnName:'orderNo', width:130},
      { columnName:'fixingEvent', width:170},
      {columnName:'deal', width:80},
      {columnName:'cmdtyPair', width:115},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:84},
      {columnName:'rate', width:100, align:'right'},
      {columnName:'docNo', width:130},
      {columnName:'placedBy', width:100, align:'right'},
      {columnName:'filledBy', width:100},
      {columnName:'account', width:145},
      {columnName:'comments', width:100, align:'right'}
    ],
    fixCancelledOrderColumnOrder:[],
    fixCancelledOrderColumnOrderExtensions:[
      {columnName:'eventTime', width:170},
      {columnName:'orderNo', width:130},
      {columnName:'fixingEvent', width:170},
      {columnName:'deal', width:80},
      {columnName:'cmdtyPair', width:115},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:84},
      {columnName:'placedBy', width:100},
      {columnName:'cancelledBy', width:100},
      {columnName:'account', width:84},
      {columnName:'accDescription', width:200},

    ],
    fixCancelledOrderColumnOrderExtensionsAR:[
      {columnName:'eventTime', width:170},
      {columnName:'orderNo', width:130},
      {columnName:'fixingEvent', width:170},
      {columnName:'deal', width:80},
      {columnName:'cmdtyPair', width:115},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:84},
      {columnName:'placedBy', width:100, align:'right'},
      {columnName:'cancelledBy', width:100},
      {columnName:'account', width:84},
      {columnName:'accDescription', width:200, align:'right'},
    ],

    integratedSortingColumnExtensions:[
      {columnName:'rate', compare:compareRate},
      {columnName:'quantity', compare:compareRate},
    ],
    // fixOutStandingOrderColumnOrder:['eventTime', 'orderNo', 'cmdtyPair', 'deal', 'quantity','outstanding','filled', 'price', 'accDescription', 'validity', 'comments'],
    fixAllOrderColumnOrder:['eventTime', 'status', 'orderNo','fixingDate','fixingEvent', 'deal', 'cmdtyPair','quantity','qtyType', 'rate', 'docNo', 'placedBy', 'account', 'comments'],
    fixFilledOrderColumnOrder:['eventTime', 'orderNo','fixingEvent','deal', 'cmdtyPair', 'quantity', 'qtyType', 'rate', 'docNo', 'placedBy', 'filledBy', 'account' ,'comments'],
    fixCancelledOrderColumnOrder:['eventTime', 'orderNo','deal', 'cmdtyPair', 'quantity', 'qtyType', 'placedBy', 'cancelledBy', 'account'],
    hiddenFixAllOrderColumnNames:[],
    hiddenFixOutStandingOrderColumnNames:[],
    hiddenFixFilledOrderColumnNames:[],
    hiddenFixCancelledOrderColumnNames:[],
    outFixSearchValue:'',
    allFixSearchValue:'',
    filledFixSearchValue:'',
    cancelledFixSearchValue:'',
    outFixColsSorting:[],
    allFixColsSorting:[],
    filledFixColsSorting:[],
    cancelledFixColsSorting:[],
    selectedAllRowsData:[],
    statusFlag:false,
    disableModifyFlag:false,
    refreshIconFlag:false,
    fixOutstandingRandomNo:0,
    fixFillRandomNo:0,
    fixCancelledRandomNo:0,
    colVisibilityExtensions:[
      {columnName:'action', togglingEnabled:false},
    ],
    selectedRowOrderNo:'',
    selectedOrderNo:'',
    selectedDocNo:'',
    fixOrdTableRowCount:0,
    orderSelection:[],
    cancelModalExtensions:[
      {columnName:'orderNo', width:130},
      {columnName:'deal', width:75},
      {columnName:'cmdtyPair', width:105},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:80},
      {columnName:'status_val', width:120},
      {columnName:'reason', width:405},
    ],
    cancelModalExtensionsAR:[
      {columnName:'orderNo', width:130, align:'right'},
      {columnName:'deal', width:75, align:'right'},
      {columnName:'cmdtyPair', width:105, align:'right'},
      {columnName:'quantity', width:100, align:'left'},
      {columnName:'qtyType', width:80, align:'right'},
      {columnName:'status_val', width:120, align:'right'},
      {columnName:'reason', align:'right'},
    ],
    cancelModalColOrder:['orderNo', 'deal', 'cmdtyPair', 'quantity', 'qtyType', 'status_val', 'reason'],
    cancelModalSorting:[],
    cancelModalSearchValue:'',
    multipleCancelModal:false,
    cancelModalrow:[],
    stopBtnReplaceflag:false,
    checkMultiCnclStatusMdl:false,
    cancelAllDisableModal: false,
    inactiveAccOnOrders: []
  }

  constructor() {
    super();

    //allLmtOrder
    this.onChangeAllLmtColOrder = this.onChangeAllLmtColOrder.bind(this);
    this.onChangeAllFixColSorting = this.onChangeAllFixColSorting.bind(this);
    this.onChangeHiddenAllFixCol = this.onChangeHiddenAllFixCol.bind(this);
    this.onChangeallFixSearchValue = this.onChangeallFixSearchValue.bind(this);

    //outLmtOrder
    this.onChangeOutFixColOrder = this.onChangeOutFixColOrder.bind(this);
    this.onChangeOutFixColSorting = this.onChangeOutFixColSorting.bind(this);
    this.onChangeHiddenOutFixCol = this.onChangeHiddenOutFixCol.bind(this);
    this.onChangeOutFixSearchValue = this.onChangeOutFixSearchValue.bind(this);

    //filledLmtOrder
    this.onChangefixFilledOrderColumnOrder=this.onChangefixFilledOrderColumnOrder.bind(this);
    this.onChangeFillColSorting=this.onChangeFillColSorting.bind(this);
    this.onChangeHiddenFilledCol=this.onChangeHiddenFilledCol.bind(this);
    this.onChangeFilledSearchValue=this.onChangeFilledSearchValue.bind(this);

    //cancelled
    this.onChangeCancelColOrder=this.onChangeCancelColOrder.bind(this);
    this.onChangeCancelColSorting=this.onChangeCancelColSorting.bind(this);
    this.onChangeHiddenCancelCol=this.onChangeHiddenCancelCol.bind(this);
    this.onChangeCancelSearchValue=this.onChangeCancelSearchValue.bind(this);

    //coloumnSelection
    this.changeOutColSelection = this.changeOutColSelection.bind(this);
    this.changeAllColSelection = this.changeAllColSelection.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);

    //CancelModalGrid
    this.onChangeCancelModalSortiog=this.onChangeCancelModalSortiog.bind(this);
    this.onChangeCancelModalColOrder=this.onChangeCancelModalColOrder.bind(this);
    this.onChangeCancelModalSearchValue=this.onChangeCancelModalSearchValue.bind(this);
  }

  componentWillMount(){
    let outColsExtension=[];
    let outColsExtensionAR=[];
    outColsExtension= [
      {columnName:'eventTime', width:170},
      {columnName:'orderNo', width:140},
      {columnName:'fixingDate', width:140},
      {columnName:'fixingEvent', width:170},
      {columnName:'deal', width:80},
      {columnName:'cmdtyPair', width:105},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:80},
      {columnName:'placedBy', width:100},
      {columnName:'account', width:140},
      {columnName:'comments', width:140},
      {columnName:'action', width:23}
    ];
    outColsExtensionAR=[
      {columnName:'eventTime', width:170},
      {columnName:'orderNo', width:140},
      {columnName:'fixingDate', width:140},
      {columnName:'fixingEvent', width:170},
      {columnName:'deal', width:80},
      {columnName:'cmdtyPair', width:105},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:80},
      {columnName:'placedBy', width:100, align:'right'},
      {columnName:'account', width:140},
      {columnName:'comments', width:140},
      {columnName:'action', width:23}
    ];

    this.setState({outFixOrdColumnExtensions:outColsExtension});
    this.setState({outFixOrdColumnExtensionsAR:outColsExtensionAR});
    this.setState({fixAllOrderColumnOrder:this.props.tradeBookColumns.fixAllOrderColumnOrder});
    this.setState({fixFilledOrderColumnOrder:this.props.tradeBookColumns.fixFilledOrderColumnOrder});
    this.setState({fixCancelledOrderColumnOrder:this.props.tradeBookColumns.fixCancelledOrderColumnOrder});
    let fixOutStandingOrderColumnOrder = this.props.tradeBookColumns.fixOutStandingOrderColumnOrder;
    let fixAllOrderColumnOrder = this.props.tradeBookColumns.fixAllOrderColumnOrder;
    let fixFilledOrderColumnOrder = this.props.tradeBookColumns.fixFilledOrderColumnOrder;
    let fixCancelledOrderColumnOrder = this.props.tradeBookColumns.fixCancelledOrderColumnOrder;

    var outColsArr =[];
    var allColsArr=[];
    var fillColsArr =[];
    var expColsArr=[];
    var cancellColsArr=[];
    for(let i=0 ; i<fixOutStandingOrderColumnOrder.length ; i++){
      var obj ={};
      if(fixOutStandingOrderColumnOrder[i] === "accDescription"){
        obj.name = fixOutStandingOrderColumnOrder[i];
        obj.title = (i18next.t('account'));
        outColsArr[i] = obj;
      }else{
        obj.name = fixOutStandingOrderColumnOrder[i];
        obj.title = (i18next.t(fixOutStandingOrderColumnOrder[i]));
        outColsArr[i] = obj;
      }
    }

    this.setState({fixOutStandingOrderColumnOrder:fixOutStandingOrderColumnOrder});
    this.setState({outFixOrdcolumns:outColsArr});

    for(let i=0 ; i< fixAllOrderColumnOrder.length ; i++){
      var obj ={};
      if(fixAllOrderColumnOrder[i] === "accDescription"){
        obj.name = fixAllOrderColumnOrder[i];
        obj.title = (i18next.t('account'));
        allColsArr[i] = obj;
      }else{
         obj.name = fixAllOrderColumnOrder[i];
        obj.title = (i18next.t(fixAllOrderColumnOrder[i]));
        allColsArr[i] = obj;
      }
    }

    this.setState({fixAllOrderColumnOrder:allColsArr});

    for(let i=0 ; i<fixFilledOrderColumnOrder.length ; i++){
      var obj ={};
      if(fixFilledOrderColumnOrder[i] === "accDescription"){
        obj.name = fixFilledOrderColumnOrder[i];
        obj.title = (i18next.t('account'));
        fillColsArr[i] = obj;
      }else{
         obj.name = fixFilledOrderColumnOrder[i];
        obj.title = (i18next.t(fixFilledOrderColumnOrder[i]));
        fillColsArr[i] = obj;
      }
    }
    this.setState({fixFilledOrderColumnOrder:fillColsArr});

    for(let i=0 ; i<fixCancelledOrderColumnOrder.length ; i++){
      var obj ={};
      if(fixCancelledOrderColumnOrder[i] === "accDescription"){
        obj.name = fixCancelledOrderColumnOrder[i];
        obj.title = (i18next.t('account'));
        cancellColsArr[i] = obj;
      }else{
         obj.name = fixCancelledOrderColumnOrder[i];
        obj.title = (i18next.t(fixCancelledOrderColumnOrder[i]));
        cancellColsArr[i] = obj;
      }
    }
    this.setState({fixCancelledOrderColumnOrder:cancellColsArr});
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    this.setState({outstngFixOrderRows:this.props.fixingOrdBook.outstandingFix.outstandingFixArr});
    this.setState({fixOrdTableRowCount:this.props.fixingOrdBook.outstandingFix.outstandingFixArr.length});
    this.setState({fixOrderFilledrows:this.props.fixingOrdBook.fixFillOrd.fixFillOrdArr});
    this.setState({fixCancelledOrderRows:this.props.fixingOrdBook.fixCancellOrd.fixCancellOrdArr});
    this.setState({allFixOrdersRows:this.props.fixingOrdBook.fixOrdersRows});
    this.setState({fixOutstandingRandomNo:this.props.fixingOrdBook.outstandingFix.randomNo});
    this.setState({fixFillRandomNo:this.props.fixingOrdBook.fixFillOrd.randomNo});
    this.setState({fixCancelledRandomNo:this.props.fixingOrdBook.fixCancellOrd.randomNo});
    this.setState({fixRandomNo:this.props.fixingOrdBook.randomNo});
    this.setState({CTID:this.props.ordersCTID});
    this.setState({refreshIconFlag:this.props.fixOrdLoaderFlag});
    this.setState({hiddenFixOutStandingOrderColumnNames :this.props.tradeBookColumns.hiddenFixOutStandingOrderColumnNames});
    this.setState({hiddenFixAllOrderColumnNames:this.props.tradeBookColumns.hiddenFixAllOrderColumnNames});
    this.setState({hiddenFixFilledOrderColumnNames:this.props.tradeBookColumns.hiddenFixFilledOrderColumnNames});
    this.setState({hiddenFixCancelledOrderColumnNames:this.props.tradeBookColumns.hiddenFixCancelledOrderColumnNames});

    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName("dropdown-item")[0], "classNames":"dropdown-item"}
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    separator = getSeparator(navigator.language,'group');
    decimal = getSeparator(navigator.language,'decimal');
  }

  componentDidUpdate(preProps){
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
  }

  componentWillReceiveProps(nextProps, nextState){
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    // //  applyStyle(thisComponent, allCssStyleRules, elementsData);
    // }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }

    if(nextProps.language !== this.props.language){
      let fixOutStandingOrderColumnOrder = nextProps.tradeBookColumns.fixOutStandingOrderColumnOrder;
      var outColsArr =[];
      for(let i=0 ; i< fixOutStandingOrderColumnOrder.length ; i++){
        var obj ={};
        if(fixOutStandingOrderColumnOrder[i] === "accDescription"){
          obj.name = fixOutStandingOrderColumnOrder[i];
          obj.title = (i18next.t('account'));
          outColsArr[i] = obj;
        }else{
          obj.name = fixOutStandingOrderColumnOrder[i];
          obj.title = (i18next.t(fixOutStandingOrderColumnOrder[i]));
          outColsArr[i] = obj;
        }
      }
      this.setState({outFixOrdcolumns:outColsArr});
      let fixAllOrdColumnOrder = nextProps.tradeBookColumns.fixAllOrderColumnOrder
      var allColsArr=[];
      for(let i=0 ; i< fixAllOrdColumnOrder.length ; i++){
        var obj ={};
        if(fixAllOrdColumnOrder[i] === "accDescription"){
          obj.name = fixAllOrdColumnOrder[i];
          obj.title = (i18next.t('account'));
          allColsArr[i] = obj;
        }else{
          obj.name = fixAllOrdColumnOrder[i];
          obj.title = (i18next.t(fixAllOrdColumnOrder[i]));
          allColsArr[i] = obj;
        }
      }
      this.setState({fixAllOrderColumnOrder:allColsArr});

      let fixFillOrdColumnOrder = nextProps.tradeBookColumns.fixFilledOrderColumnOrder;
      var fillColsArr =[];
      for(let i=0 ; i< fixFillOrdColumnOrder.length ; i++){
        var obj ={};
        if(fixFillOrdColumnOrder[i] === "accDescription"){
          obj.name = fixFillOrdColumnOrder[i];
          obj.title = (i18next.t('account'));
          fillColsArr[i] = obj;
        }else {
          obj.name = fixFillOrdColumnOrder[i];
          obj.title = (i18next.t(fixFillOrdColumnOrder[i]));
          fillColsArr[i] = obj;
        }
      }
      this.setState({fixFilledOrderColumnOrder:fillColsArr});

      let fixCancelledOrdColumnOrder = nextProps.tradeBookColumns.fixCancelledOrderColumnOrder;
      var cancellColsArr=[];
      for(let i=0 ; i< fixCancelledOrdColumnOrder.length ; i++){
        var obj ={};
        if(fixCancelledOrdColumnOrder[i] === "accDescription"){
          obj.name = fixCancelledOrdColumnOrder[i];
          obj.title = (i18next.t('account'));
          cancellColsArr[i] = obj;
        }else {
          obj.name = fixCancelledOrdColumnOrder[i];
          obj.title = (i18next.t(fixCancelledOrdColumnOrder[i]));
          cancellColsArr[i] = obj;
        }
      }
      this.setState({fixCancelledOrderColumnOrder:cancellColsArr});
    }

    if(nextProps.fixOrdLoaderFlag !== this.props.fixOrdLoaderFlag){
      this.setState({refreshIconFlag:nextProps.fixOrdLoaderFlag});
    }

    if(this.props.requestRejectModal !== nextProps.requestRejectModal){
      if(nextProps.requestRejectModal.title !== "" && nextProps.requestRejectModal.OT === 4){
        if(nextProps.requestRejectModal.bcm === '107' || nextProps.requestRejectModal.bcm === '106' || nextProps.requestRejectModal.bcm === '111' || nextProps.requestRejectModal.bcm === '308' ) {
          fixOrdRectFlag=true;
        }
      }
    }

    if (nextProps.statusChanged.length>0 && this.state.multipleCancelModal === true) {
      let updateStatus=[];
      updateStatus= this.state.cancelModalrow;
      for (var i = 0; i < nextProps.statusChanged.length; i++) {
        for (var j = 0; j < updateStatus.length; j++) {
          if (nextProps.statusChanged[i].docNo === updateStatus[j].orderNo) {
            updateStatus[j].status_val = nextProps.statusChanged[i].status_val;
            updateStatus[j].reason = nextProps.statusChanged[i].reason;
          }
        }
      }
      this.setState({cancelModalrow:updateStatus});
      fixOrdRectFlag=false;
    }

    if(nextProps.fixOrdRandomNoDB !== this.props.fixOrdRandomNoDB){
      var outObj=nextProps.fixingOrdBook.outstandingFix.outstandingFixArr;
      var allObj=nextProps.fixingOrdBook.fixOrdersRows;
      var fillObj= nextProps.fixingOrdBook.fixFillOrd.fixFillOrdArr;
      var cncelledObj= nextProps.fixingOrdBook.fixCancellOrd.fixCancellOrdArr;
      var outFixRows = [];
      var allFixRows = [];
      var filledFixRows = [];
      var cncelledFixRows = [];
      this.setState({outstngFixOrderRows:outFixRows.concat(outObj)});
      this.setState({allFixOrdersRows:allFixRows.concat(allObj)});
      this.setState({fixOrderFilledrows:filledFixRows.concat(fillObj)});
      this.setState({fixCancelledOrderRows:cncelledFixRows.concat(cncelledObj)});
      this.setState({selectFIX:this.state.selectFIX});
      this.setState({selectFIXKey:this.state.selectFIXKey});
      let fixOrdTableRowCount=this.state.selectFIXKey === 'A' ? nextProps.fixingOrdBook.fixOrdersRows.length :
      this.state.selectFIXKey === 'O' ? nextProps.fixingOrdBook.outstandingFix.outstandingFixArr.length :
      this.state.selectFIXKey === 'F' ? nextProps.fixingOrdBook.fixFillOrd.fixFillOrdArr.length :
      nextProps.fixingOrdBook.fixCancellOrd.fixCancellOrdArr.length
      this.setState({fixOrdTableRowCount:fixOrdTableRowCount});
      this.props.fixOrdRefreshFlag(false);
    }

    //outstanding Fixing Order
    if(nextProps.fixingOrdBook.outstandingFix.outstandingFixArr.length === 0){
      this.setState({outstngFixOrderRows:nextProps.fixingOrdBook.outstandingFix.outstandingFixArr});
    }

    if (nextProps.fixingOrdBook.outstandingFix.randomNo !== this.state.fixOutstandingRandomNo) {
      var outstngFixOrderRows = [];
      var obj=nextProps.fixingOrdBook.outstandingFix.outstandingFixArr;
      this.setState({outstngFixOrderRows:outstngFixOrderRows.concat(obj)});
      this.setState({fixOutstandingRandomNo:nextProps.fixingOrdBook.outstandingFix.randomNo});
      this.props.fixOrdRefreshFlag(false);
      this.setState({selectFIX:i18next.t("outstanding")});
      this.setState({selectFIXKey:'O'});
      this.setState({fixOrdTableRowCount:nextProps.fixingOrdBook.outstandingFix.outstandingFixArr.length});
      var allFixOrdersRows = [];
      var obj='';
      obj=nextProps.fixingOrdBook.fixOrdersRows;
      this.setState({allFixOrdersRows:allFixOrdersRows.concat(obj)});
    }

    //filled Fixing order
    if(this.state.fixOrderFilledrows.length !== nextProps.fixingOrdBook.fixFillOrd.fixFillOrdArr.length){
      if (nextProps.fixingOrdBook.fixFillOrd.randomNo !== this.state.fixFillRandomNo){
        var fixOrderFilledrows = [];
        var obj=nextProps.fixingOrdBook.fixFillOrd.fixFillOrdArr;
        this.setState({fixOrderFilledrows:fixOrderFilledrows.concat(obj)});
        this.setState({fixFillRandomNo:nextProps.fixingOrdBook.fixFillOrd.randomNo});
        this.props.fixOrdRefreshFlag(false);
        this.setState({selectFIX:i18next.t("filled")});
        this.setState({selectFIXKey:'F'});
        this.setState({fixOrdTableRowCount:nextProps.fixingOrdBook.fixFillOrd.fixFillOrdArr.length});
        var allFixOrdersRows = [];
        var obj='';
        obj=nextProps.fixingOrdBook.fixOrdersRows;
        this.setState({allFixOrdersRows:allFixOrdersRows.concat(obj)});
      }
    }

    //cancelled Fixing Order
    if(this.state.fixCancelledOrderRows.length !== nextProps.fixingOrdBook.fixCancellOrd.fixCancellOrdArr.length){
      if ( nextProps.fixingOrdBook.fixCancellOrd.randomNo !== this.state.fixCancelledRandomNo) {
        var fixCancelledOrderRows = [];
        var obj=nextProps.fixingOrdBook.fixCancellOrd.fixCancellOrdArr;
        this.setState({fixCancelledOrderRows:fixCancelledOrderRows.concat(obj)});
        this.setState({fixCancelledRandomNo:nextProps.fixingOrdBook.fixCancellOrd.randomNo});
        var outstngFixOrderRows = [];
        var obj=nextProps.fixingOrdBook.outstandingFix.outstandingFixArr;
        this.setState({outstngFixOrderRows:outstngFixOrderRows.concat(obj)});
        this.props.fixOrdRefreshFlag(false);
        this.setState({selectFIX:i18next.t("cancelled")});
        this.setState({selectFIXKey:'C'});
        this.setState({fixOrdTableRowCount:nextProps.fixingOrdBook.fixCancellOrd.fixCancellOrdArr.length});
        var allFixOrdersRows = [];
        var obj='';
        obj=nextProps.fixingOrdBook.fixOrdersRows;
        this.setState({allFixOrdersRows:allFixOrdersRows.concat(obj)});
      }
    }

    if(nextProps.fixModifyFlag !== this.props.fixModifyFlag){
      if(nextProps.fixModifyFlag === false){
        this.setState({enableFixingModifyFlag:false});
        this.setState({orderSelection:[]});
      }
    }

    if(this.state.CTID !== nextProps.ordersCTID){
      this.setState({CTID:nextProps.ordersCTID});
    };

    if(nextProps.navigationStatus !== this.props.navigationStatus){
      this.setState({selectedRowOrderNo:''});
    }

  }

  //outLmt
  onChangeOutFixColOrder(newOrder) {
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.fixOutStandingOrderColumnOrder=newOrder;
      this.setState({ fixOutStandingOrderColumnOrder:newOrder });
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeOutFixColOrder', component:"FixingOrderTableComponent"});
    }
  }

  onChangeOutFixColSorting(sorting) {
    try{
      this.setState({outFixColsSorting:sorting});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeOutFixColSorting', component:"FixingOrderTableComponent"});
    }
  }

  onChangeHiddenOutFixCol(hiddenFixOutStandingOrderColumnNames){
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.hiddenFixCancelledOrderColumnNames=hiddenFixOutStandingOrderColumnNames;
      this.setState({hiddenFixOutStandingOrderColumnNames:hiddenFixOutStandingOrderColumnNames});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenOutFixCol', component:"FixingOrderTableComponent"});
    }
  };

  onChangeOutFixSearchValue(value){
    try{
      this.setState({outFixSearchValue:value });
      var count=getCountofTableRows(this.state.outstngFixOrderRows, this.props.tradeBookColumns.fixOutStandingOrderColumnOrder, value);
      this.setState({fixOrdTableRowCount:count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeOutFixSearchValue', component:"FixingOrderTableComponent"});
    }
  }

  //allLmtOrder
  onChangeAllLmtColOrder(newOrder) {
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.fixAllOrderColumnOrder=newOrder;
      this.setState({fixAllOrderColumnOrder:newOrder});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeAllLmtColOrder', component:"FixingOrderTableComponent"});
    }
  }

  onChangeAllFixColSorting(sorting) {
    try{
      this.setState({ outFixColsSorting:sorting });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeAllFixColSorting', component:"FixingOrderTableComponent"});
    }
  }

  onChangeHiddenAllFixCol(hiddenCol){
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.hiddenFixAllOrderColumnNames=hiddenCol;
      this.setState({ hiddenFixAllOrderColumnNames:hiddenCol});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenAllFixCol', component:"FixingOrderTableComponent"});
    }
  };

  onChangeallFixSearchValue(value){
    try{
      this.setState({allFixSearchValue:value });
      var count=getCountofTableRows(this.state.allFixOrdersRows, this.props.tradeBookColumns.fixAllOrderColumnOrder, value);
      this.setState({fixOrdTableRowCount:count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeallFixSearchValue', component:"FixingOrderTableComponent"});
    }
  }

  //FILLED
  onChangefixFilledOrderColumnOrder(newOrder) {
    try{
      this.setState({ fixFilledOrderColumnOrder:newOrder });
      let trdCols =this.props.tradeBookColumns;
      trdCols.fixFilledOrderColumnOrder=newOrder;
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangefixFilledOrderColumnOrder', component:"FixingOrderTableComponent"});
    }
  }

  onChangeFillColSorting(sorting) {
    try{
      this.setState({ filledFixColsSorting:sorting });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeFillColSorting', component:"FixingOrderTableComponent"});
    }
  }

  onChangeHiddenFilledCol(hiddenCol){
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.hiddenFixFilledOrderColumnNames=hiddenCol;
      this.setState({ hiddenFixFilledOrderColumnNames:hiddenCol});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenFilledCol', component:"FixingOrderTableComponent"});
    }
  };

  onChangeFilledSearchValue(value){
    try{
      this.setState({filledFixSearchValue:value });
      var count=getCountofTableRows(this.state.fixOrderFilledrows, this.props.tradeBookColumns.fixFilledOrderColumnOrder, value);
      this.setState({fixOrdTableRowCount:count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeFilledSearchValue', component:"FixingOrderTableComponent"});
    }
  }

  //Cancelled
  onChangeCancelColOrder(newOrder) {
    try{
      this.setState({ fixCancelledOrderColumnOrder:newOrder });
      let trdCols =this.props.tradeBookColumns;
      trdCols.fixCancelledOrderColumnOrderr=newOrder;
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCancelColOrder', component:"FixingOrderTableComponent"});
    }
  }

  onChangeCancelColSorting(sorting) {
    try{
      this.setState({ cancelledFixColsSorting:sorting });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCancelColSorting', component:"FixingOrderTableComponent"});
    }
  }

  onChangeHiddenCancelCol(hiddenCol){
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.hiddenFixCancelledOrderColumnNames=hiddenCol;
      this.setState({ hiddenFixCancelledOrderColumnNames:hiddenCol});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenCancelCol', component:"FixingOrderTableComponent"});
    }
  };

  onChangeCancelSearchValue(value){
    try{
      this.setState({cancelledFixSearchValue:value });
      var count=getCountofTableRows(this.state.fixCancelledOrderRows, this.props.tradeBookColumns.fixCancelledOrderColumnOrder, value);
      this.setState({fixOrdTableRowCount:count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCancelSearchValue', component:"FixingOrderTableComponent"});
    }
  }

  editFixingOrdModal = (event) => {
    try{
      let showPrice = this.props.userDetail.showPrice == "BID" ? 'SELL' : this.props.userDetail.showPrice === "ASK" ? 'BUY' : 'BOTH';
      let deal = (this.state.orderSelection.length === 1 ?this.state.orderSelection[0].deal :'');
      let showPriceValMsg = this.props.userDetail.showPrice == "BID" ? 'BUY' : this.props.userDetail.showPrice === "ASK" ? 'SELL' : 'BOTH';
      const orderAcc = getAccountByCode(this.props.ACD, this.state.orderSelection[0]?.accCode)
      if(parseInt(this.props.status) !== 0){
        this.setState({statusFlag:true});
      } else if(this.state.orderSelection.length === undefined || this.state.orderSelection.length === 0 && parseInt(this.props.status) === 0){
        this.setState({disableModifyFlag:true});
        this.setState({fixEditErrMsgHeader:"modifyOrds"});
        this.setState({fixEditErrMsg:"selectOrdModifyMsg"});
      } else if(this.state.orderSelection.length > 1 && parseInt(this.props.status) === 0){
          this.setState({disableModifyFlag:true});
          this.setState({fixEditErrMsgHeader:"Modify Order"});
          this.setState({fixEditErrMsg:"Please select only one order to modify"});
      } else if(deal !== showPrice && this.props.userDetail.showPrice!=='BOTH'){
          this.setState({disableModifyFlag:true});
          this.setState({fixEditErrMsgHeader:"Modify Order"});
          this.setState({fixEditErrMsg:showPriceValMsg+" price disabled for your account. Please contact the Trading Desk in order to amend this order."});
      } else if(!Number(orderAcc.isActiveAcc)) {
          this.setState({disableModifyFlag:true});
          this.setState({fixEditErrMsgHeader:"Modify Order"});
          this.setState({fixEditErrMsg:displayInActiveAccMsg(orderAcc.D,orderAcc.C)});
      } else{
        this.setState({FIXModel:true});
        this.props.closeFixModifypopup(true);
        this.setState({enableFixingModifyFlag:true});
        this.props.handleFixingModal(true);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeOutFixColOrder', component:"FixingOrderTableComponent"});
    }
  }

  //onclick cancelled order to open modal
  cancelFixOrdModal = (event) => {
    try{
      const orderAcc = getAccountByCode(this.props.ACD, this.state.orderSelection[0]?.accCode)
      const inactiveAccounts = getInactiveAccounts(this.state.orderSelection, this.props.ACD);
      this.setState({stopBtnReplaceflag:false});
      if(parseInt(this.props.status) !== 0){
        this.setState({statusFlag:true});
      }
      if(this.state.orderSelection.length === undefined || this.state.orderSelection.length === 0 && parseInt(this.props.status) === 0){
        this.setState({disableModifyFlag:true});
        this.setState({fixEditErrMsgHeader:"cancelOrd"});
        this.setState({fixEditErrMsg:"selectOrdCancelMsg"});
        return
      }
      if(this.state.orderSelection.length > 1 && inactiveAccounts.length) {
        this.setState({cancelAllDisableModal:true});
        this.setState({fixEditErrMsgHeader:"cancelOrd"});
        this.setState({fixEditErrMsg:`followingAccountsInactive`});
        this.setState({inactiveAccOnOrders: inactiveAccounts});
        return
      }
      if(!Number(orderAcc.isActiveAcc)) {
        this.setState({disableModifyFlag:true});
        this.setState({fixEditErrMsgHeader:"cancelOrd"});
        this.setState({fixEditErrMsg:displayInActiveAccMsg(orderAcc.D,orderAcc.C)});
        return
      }
      if(this.state.orderSelection.length === 1 && parseInt(this.props.status) === 0){
        this.setState({cancelFIXModel:true});
        this.props.orderSelectionFunc(true);
      }
      if(this.state.orderSelection.length >1 && parseInt(this.props.status) === 0){
          this.setState({cancelFIXModel:true});
          this.props.orderSelectionFunc(false);
          this.setState({selectedOrderNo:''});
          this.setState({selectedDocNo:''});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelFixOrdModal', component:"FixingOrderTableComponent"});
    }
  }

  @track((props, state) => ({ 
    widgetDetails: { originFunction: "cancelFIXOrder", event: appConstants.trackingEvents.CANCEL_ORDER},
    ordDetails: [wsData]
  }))

  //single cancel
  cancelFIXOrder = (fixArrayList) => {
    try{
      if(this.state.orderSelection.length === 1 && parseInt(this.props.status) === 0){
        let index1;
        var orderDetailsArray=[];
        var OMT = 6;
        var PCT = 4;
        var DT;
        let cmdtyId;
        var orderDetails;
        fixArrayList.map((item) => {
          orderDetails=this.props.fixingOrdBook.fixingOrdMap.get(item.orderNo);
          var DealTypeBM = orderDetails.deal;
          var socketDataMap = this.props.socketData.get(orderDetails.cmdtyId);
          if (DealTypeBM.toUpperCase() === config.buy) {
            let price = socketDataMap.MA;
            DT = 1;
          } else {
            let price = socketDataMap.MB;
            DT = 0;
          }
          let com=socketDataMap.B;
          var valueDate = socketDataMap.VD;
          if(com===1)
          {
            orderDetails.OSC="";
          }
          orderDetailsArray.push(orderDetails);
        });
        this.setState({selectedOrderNo:orderDetails.orderNo});
        this.setState({selectedDocNo:orderDetails.orderNo});
        this.setState({fixingOrdersRows:this.state.fixingOrdersRows});
        this.setState({outstngFixOrderRows:this.state.outstngFixOrderRows});
        this.setState({cancelModalrow:this.state.cancelModalrow});
        this.setState({cancelFIXModel:false});
        let fixingDate = moment(orderDetails.fixingDate,"DD-MMM-YYYY").format('YYYY/MM/DD');
        let Price = (orderDetails.OR).replace(separator,'')
        Price = (Price).replace(getSeparator(navigator.language,'decimal'),getSeparator('en-US','decimal'));//1500.60-----1.500,62
        let Qty = (orderDetails.quantity).replace(separator,'')
        Qty = (Qty).replace(getSeparator(navigator.language,'decimal'),getSeparator('en-US','decimal'));//1500.60-----1.500,62
        // console.log(" Price "+ Price +" QTY" + Qty);
        const user = JSON.parse(localStorage.getItem('user'));
        const AccDet=JSON.parse(localStorage.getItem('DFA'));
        if (user === null) {
          dispatch(sessionTimeout());
        }
        let processedData={
          "MT": "CANCEL_ORDER",
          "UID": user.UID,
          "UD": user.UD,
          "UCD": user.trdCode,
          "IID": orderDetails.cmdtyId,
          "PQ": Qty,
          "DT": orderDetails.DT,
          "OT": 4,
          "CID": user.location,
          "AC": AccDet.accCode,
          "AD": AccDet.accDescription,
          "SC": orderDetails.OSC,
          "OMT": 6,
          "PCT": 21,
          "RMK": orderDetails.comments,
          "SID": user.SID,
          "FC": orderDetails.fixingEventCode,
          "FN": orderDetails.fixingEvent,
          "FT": orderDetails.fixingEventTime,
          "CTID": orderDetails.CTID,
          "MD": -1,
          "FD": fixingDate,
          "OrderNo": orderDetails.orderNo
        };

        wsData={
            "MT": "CANCEL_ORDER",
            "UID": user.UID,
            "UD": user.UD,
            "UCD": user.trdCode,
            "IID": orderDetails.cmdtyId,
            "PQ": Qty,
            "DT": orderDetails.DT,
            "OT": 4,
            "CID": user.location,
            "AC": AccDet.accCode,
            "AD": AccDet.accDescription,
            "SC": orderDetails.OSC,
            "OMT": 6,
            "PCT": 21,
            "RMK": orderDetails.comments,
            "SID": user.SID,
            "FC": orderDetails.fixingEventCode,
            "FN": orderDetails.fixingEvent,
            "FT": orderDetails.fixingEventTime,
            "CTID": orderDetails.CTID,
            "MD": -1,
            "FD": fixingDate,
            "OrderNo": orderDetails.orderNo,
          };

          let apiValidateData=[{"processedData":processedData},{"wsData":wsData}]
          this.props.validateOrder(JSON.stringify(apiValidateData));
          this.props.handleCancelledFIX(orderDetails,fixingDate,Price,Qty);
        this.setState({orderSelection:[]});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelFIXOrder', component:"FixingOrderTableComponent"});
    }
  }

  multipleCancelFIXOrder = (fixArrayList) => {
    try{
      if(this.state.orderSelection.length > 1 && parseInt(this.props.status) === 0){
        var OMT=6;
        let cancelArraymodal=[];
        if(this.state.selectFIXKey==="O"){
          this.state.orderSelection.map((order)=>{
            var obj={
              'orderNo':order.orderNo,
              'deal':order.deal,
              'cmdtyPair':order.cmdtyPair,
              'quantity':order.quantity,
              'qtyType':order.qtyType,
              'status_val':"Pending",
              'reason':"",
            }
            cancelArraymodal.push(obj);
          });
        } else if(this.state.selectFIXKey==="A"){
          this.state.orderSelection.map((order)=>{
            var obj={
              'orderNo':order.orderNo,
              'deal':order.deal,
              'cmdtyPair':order.pair,
              'quantity':order.quantity,
              'qtyType':order.qtyType,
              'status_val':"Pending",
              'reason':"",
            }
            cancelArraymodal.push(obj);
          });
        }
        this.setState({cancelModalrow:cancelArraymodal});
        this.setState({multipleCancelModal:true});
        for (let i=0; i<cancelArraymodal.length; i++){
          setTimeout(()=>{
            selectedRowsToCancel[i].status_val="In Progress";
            if(this.state.stopBtnReplaceflag===true){
              for (var j = 0; j < cancelArraymodal.length; j++) {
                if(cancelArraymodal[j].status_val==="Pending"){
                  cancelArraymodal[j].status_val="Stopped";
                  selectedRowsToCancel[j].status_val="Stopped";
                }
              }
              this.setState({cancelModalrow:cancelArraymodal});
            } else {
              if(cancelArraymodal[i].status_val==="Pending"){
                cancelArraymodal[i].status_val="In Progress";
                selectedRowsToCancel[i].status_val="In Progress";
              }
            }
          },i*2000);
          setTimeout(()=>{
            if(cancelArraymodal[i].status_val==="In Progress"){
              this.cancelMultipleFIXOrder(selectedRowsToCancel[i],i);
              fixOrdRectFlag=false;
            }
          },i*3000);
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'multipleCancelFIXOrder', component:"FixingOrderTableComponent"});
    }
  }

  @track((props, state) => ({ 
    widgetDetails: { originFunction: "cancelMultipleFIXOrder", event: appConstants.trackingEvents.CANCEL_ORDER},
    ordDetails: [wsData]
  }))

  //Multiple cancelLMTOrder
  cancelMultipleFIXOrder = (fixArrayList,index) => {
    try{
      let index1;
      var orderDetailsArray=[];
      var OMT = 6;
      var PCT = 4;
      var DT;
      let cmdtyId;
      var orderDetails;
      orderDetails=this.props.fixingOrdBook.fixingOrdMap.get(fixArrayList.orderNo);
      var DealTypeBM = orderDetails.deal;
      var socketDataMap = this.props.socketData.get(orderDetails.cmdtyId);
      if (DealTypeBM.toUpperCase() === config.buy) {
        let price = socketDataMap.MA;
        DT = 1;
      } else {
        let price = socketDataMap.MB;
        DT = 0;
      }
      let com=socketDataMap.B;
      var valueDate = socketDataMap.VD;
      if(com===1) {
        orderDetails.OSC="";
      }
      orderDetailsArray.push(orderDetails);
      this.setState({fixingOrdersRows:this.state.fixingOrdersRows});
      this.setState({outstngFixOrderRows:this.state.outstngFixOrderRows});
      this.setState({cancelFIXModel:false});

      for(let i=0; i< orderDetailsArray.length; i++){
        let fixingDate = moment(orderDetailsArray[i].fixingDate,"DD-MMM-YYYY").format('YYYY/MM/DD');
        let Price = (orderDetailsArray[i].OR).replace(separator,'')
        Price = (Price).replace(getSeparator(navigator.language,'decimal'),getSeparator('en-US','decimal'));//1500.60-----1.500,62
        let Qty = (orderDetailsArray[i].quantity).replace(separator,'')
        Qty = (Qty).replace(getSeparator(navigator.language,'decimal'),getSeparator('en-US','decimal'));//1500.60-----1.500,62


          const user = JSON.parse(localStorage.getItem('user'));
          const AccDet=JSON.parse(localStorage.getItem('DFA'));
          if (user === null) {
            dispatch(sessionTimeout());
          }
          let processedData={
            "MT": "CANCEL_ORDER",
            "UID": user.UID,
            "UD": user.UD,
            "UCD": user.trdCode,
            "IID": orderDetailsArray[i].cmdtyId,
            "PQ": Qty,
            "DT": orderDetailsArray[i].DT,
            "OT": 4,
            "CID": user.location,
            "AC": AccDet.accCode,
            "AD": AccDet.accDescription,
            "SC": orderDetailsArray[i].OSC,
            "OMT": 6,
            "PCT": 21,
            "RMK": orderDetailsArray[i].comments,
            "SID": user.SID,
            "FC": orderDetailsArray[i].fixingEventCode,
            "FN": orderDetailsArray[i].fixingEvent,
            "FT": orderDetailsArray[i].fixingEventTime,
            "CTID": orderDetailsArray[i].CTID,
            "MD": -1,
            "FD": fixingDate,
            "OrderNo": orderDetailsArray[i].orderNo
          };

          wsData={
              "MT": "CANCEL_ORDER",
              "UID": user.UID,
              "UD": user.UD,
              "UCD": user.trdCode,
              "IID": orderDetailsArray[i].cmdtyId,
              "PQ": Qty,
              "DT": orderDetailsArray[i].DT,
              "OT": 4,
              "CID": user.location,
              "AC": AccDet.accCode,
              "AD": AccDet.accDescription,
              "SC": orderDetailsArray[i].OSC,
              "OMT": 6,
              "PCT": 21,
              "RMK": orderDetailsArray[i].comments,
              "SID": user.SID,
              "FC": orderDetailsArray[i].fixingEventCode,
              "FN": orderDetailsArray[i].fixingEvent,
              "FT": orderDetailsArray[i].fixingEventTime,
              "CTID": orderDetailsArray[i].CTID,
              "MD": -1,
              "FD": fixingDate,
              "OrderNo": orderDetailsArray[i].orderNo,
            };

            let apiValidateData=[{"processedData":processedData},{"wsData":wsData}]
            this.props.validateOrder(JSON.stringify(apiValidateData));
            this.props.handleCancelledFIX(orderDetailsArray[i],fixingDate,Price,Qty);
          if (index == this.state.cancelModalrow.length-1) {
            this.setState({stopBtnReplaceflag:true});
          }
      }
      this.setState({orderSelection:[]});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelMultipleFIXOrder', component:"FixingOrderTableComponent"});
    }
  }

  stopBtnclick=(event)=>{
    try{
      this.setState({stopBtnReplaceflag:true});
      this.setState({orderSelection:[]});
      this.setState({cancelModalSearchValue:''});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'stopBtnclick', component:"FixingOrderTableComponent"});
    }
  }

  closeBtnclick=(event)=>{
    try{
      this.setState({stopBtnReplaceflag:false});
      this.setState({multipleCancelModal:false});
      this.setState({orderSelection:[]});
      this.setState({cancelModalSearchValue:''});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeBtnclick', component:"FixingOrderTableComponent"});
    }
  }

  //close modify limit ord modal
  closeFixOrdpopup = (event) => {
    try{
      this.setState({selectedRowOrderNo:''});
      this.setState({FIXModel:false});
      this.props.closeFixModifypopup(false);
      this.setState({enableFixingModifyFlag:false});
      this.props.handleFixingModal(false);
      this.setState({selectedOrderNo:''});
      this.setState({selectedDocNo:''});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeFixOrdpopup', component:"FixingOrderTableComponent"});
    }
  }

  refreshComponentData =()=>{
    try{
      this.props.fixOrdRefreshFlag(true);
      this.props.getFixingOrder();
      this.setState({selectFIX:this.state.selectFIX});
      this.setState({selectFIXKey:this.state.selectFIXKey});
      this.setState({selectedRowOrderNo:''});
      this.setState({outFixSearchValue:''});
      this.setState({allFixSearchValue:''});
      this.setState({filledFixSearchValue:''});
      this.setState({cancelledFixSearchValue:''});
      this.setState({selectedOrderNo:''});
      this.setState({selectedDocNo:''});
      this.setState({orderSelection:[]});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'refreshComponentData', component:"FixingOrderTableComponent"});
    }
  }

  selectFIX = (text,value) => {
    try{
      this.setState({selectFIX:text});
      this.setState({selectFIXKey:value});
      let fixOrdTableRowCount = value === 'A' ? this.state.allFixOrdersRows.length :
      value === 'O' ? this.state.outstngFixOrderRows.length :
      value === 'F' ? this.state.fixOrderFilledrows.length :
      this.state.fixCancelledOrderRows.length
      this.setState({fixOrdTableRowCount:fixOrdTableRowCount});
      this.setState({selectedRowOrderNo:''});
      this.setState({selectedOrderNo:''});
      this.setState({selectedDocNo:''});
      this.setState({orderSelection:[]});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'selectFIX', component:"FixingOrderTableComponent"});
    }
  }

  closeReqRejectModal =()=>{
    try{
      this.setState({outstngFixOrderRows:this.state.outstngFixOrderRows});
      this.setState({fixOrdersRows:this.state.fixOrdersRows});
      fixOrdRectFlag=false;
      this.props.closeReqRejectModal(this.props.requestRejectModal);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeReqRejectModal', component:"FixingOrderTableComponent"});
    }
  }

  cancelStatusModal = (event) => {
    try{
      this.setState({statusFlag:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelStatusModal', component:"FixingOrderTableComponent"});
    }
  }

  cancelFixCnfrmBox = (event) => {
    try{
      this.setState({cancelFIXModel:false});
      this.setState({orderSelection:[]});
      this.setState({selectedOrderNo:''});
      this.setState({selectedDocNo:''});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelFixCnfrmBox', component:"FixingOrderTableComponent"});
    }
  }

  closeMultipleCancelModal= (event) => {
    try{
      this.setState({stopBtnReplaceflag:true});
      this.setState({multipleCancelModal:false});
      this.setState({orderSelection:[]});
      this.setState({cancelModalSearchValue:''});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeMultipleCancelModal', component:"FixingOrderTableComponent"});
    }
  }

  //Close errorMsg Modal
  cancelDisableModifyModal = (event) => {
    try{
      this.setState({disableModifyFlag:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelDisableModifyModal', component:"FixingOrderTableComponent"});
    }
  }

  closeCancelAllDisableModal = (event) => {
    try {
      this.setState({cancelAllDisableModal: false, inactiveAccOnOrders: []})
    } catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeCancelAllDisableModal', component:"FixingOrderTableComponent"});
    }
  }


  changeOutColSelection=(selection)=>{
    try{
      this.setState({orderSelection:selection});
      selectedRowsToCancel = selection;
      if (selection.length>0) {
        this.setState({selectedOrderNo:selection[0].orderNo});
      }
      this.setState({selectedRowsData:this.state.outstngFixOrderRows.filter(
        row => selection.findIndex(selectId => selectId === getRowId(row)) !== -1
      )});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeOutColSelection', component:"FixingOrderTableComponent"});
    }
  }

  changeAllColSelection=(selection)=>{
    try{
      this.setState({orderSelection:selection});
      selectedRowsToCancel = selection;
      if (selection.length>0) {
        this.setState({selectedDocNo:selection[0].orderNo});
      }
      this.setState({selectedRowsData:this.state.allFixOrdersRows.filter(
        row => selection.findIndex(selectId => selectId === getRowId(row)) !== -1
      )});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeAllColSelection', component:"FixingOrderTableComponent"});
    }
  }

  generateInvoice=(row)=>{
    try{
      var docNo=row.toString().split('""');
      var getdocType = row.toString().split('/');
      var docType=getdocType[0];
      if(docType !== 'PFC'){
        this.props.getInvoice(docNo,docType);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'generateInvoice', component:"FixingOrderTableComponent"});
    }
  }

  closeFixingOrdpopup = (event) => {
    try{
      this.props.closeFixModifypopup(false);
      this.props.handleFixingModal(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeFixingOrdpopup', component:"FixingOrderTableComponent"});
    }
  }

  onChangeCancelModalSortiog(sorting){
    try{
      this.setState({cancelModalSorting:sorting });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCancelModalSortiog', component:"FixingOrderTableComponent"});
    }
  }

  onChangeCancelModalColOrder(order){
    try{
      this.setState({cancelModalColOrder:order});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCancelModalColOrder', component:"FixingOrderTableComponent"});
    }
  }

  onChangeCancelModalSearchValue(value){
    try{
      this.setState({cancelModalSearchValue:value });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCancelModalSearchValue', component:"FixingOrderTableComponent"});
    }
  }

  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      //const allCssStyleRules = this.props.selectedCssColorTheme;
      // const elementsData = [
      //   {"classNames":"errorheader", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"msgWrap", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"mdlWrap", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      //   {"classNames":"lmtClose","elementType":"normal", "applyTo":"all", "tagNames":"button"},
      //   {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"form-control","elementType":"tag", "applyTo":"all", "tagNames":"input"},
      //   {"classNames":"oi-eye","elementType":"tag", "applyTo":"all", "tagNames":"span"},
      // ];

    // applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {"classNames":"errorheader", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"trdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"modalCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"lmtClose","elementType":"normal", "applyTo":"all", "tagNames":"button"},
        {"classNames":"cancelRowTblDiv", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"cancelConfrmBtn", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      ];

      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"},
        {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[1], "classNames":"lmtClose"}
        //{"elmToHover":thisComponent.getElementsByClassName('dropDownList')[0], "classNames":"dropDownList"}
      ];

      //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"FixingOrderTableComponent"});
    }
  }

  render() {
    //hide column Name
    const TableHeaderContent = ({ column, children}) => (
      <TableHeaderRow.Content>
        {column.name !== 'action' ?
        (<span>{children} </span>) : null}
      </TableHeaderRow.Content>
    );

    const FillOrdersCell = props => {
      const { column } = props;
      if (column.name === "docNo") {
        return <InvoiceHighlightedCell {...props} />;
      }
      if(column.name === "eventTime"){
        return <Table.Cell {...props} className="eventTimeCell" />;
      }
      return <Table.Cell {...props} />;
    };

    //AlL orders
    const AllOrdersCell = props => {
      const { column } = props;
      let cnt =0;
      if (column.name === "action" ) {
        return <CellWithRadioBtn {...props} />;
      }
      if (column.name === "docNo") {
        return <InvoiceHighlightedCell {...props} />;
      }
      if(column.name === "eventTime"){
        return <Table.Cell {...props} className="eventTimeCell" />;
      }
      return <Table.Cell {...props} />;
    };

    const Cell = props => {
      const { column } = props;
      if(column.name === "eventTime"){
        return <Table.Cell {...props} className="eventTimeCell" />;
      }
      return <Table.Cell {...props} />;
    };

    const CellWithRadioBtn = (props) => {
      return (
        <Table.Cell>
          {props.tableRow.row.status === 'Outstanding' ?
            <input
              type="radio"
              name="radioBtn"
              value={this.state.selectedRowOrderNo}
              onChange={()=>this.changeOutColSelection(props)}
              checked={this.state.selectedRowOrderNo === props.tableRow.row.orderNo}
            />
          : null}
        </Table.Cell>
      );
    }

    const InvoiceHighlightedCell = ({ value, style }) => (
      <Table.Cell>
        <span>
          {value.indexOf('PFC') === -1 ?
            <a className='trdeBookCell' title={i18next.t("invoiceDownldMsg")} onClick={()=>this.generateInvoice(value)}>{value}</a>
          : value}
        </span>
      </Table.Cell>
    );

    const selectedfont_size ="fontSize_"+this.props.userDetail.fontSize;
    const CloseIcon = <MUIIconWithTooltip icon={'Close'} className={`closeBtn`} title={i18next.t("close")}/>;
    const closeIconImg = <div className={styles.lmtCloseIconImg}><img width="16px" src="/images/close.png" /></div>;
    var OutstandingOrderHeader ='';
    if(this.props.userDetail.fontSize == 'S'){
      OutstandingOrderHeader = 'tradeBookHeaderSfont';
    } else if(this.props.userDetail.fontSize == 'N'){
      OutstandingOrderHeader = 'tradeBookHeaderMfont'
    } else{
      OutstandingOrderHeader = 'tradeBookHeaderLfont'
    }

    const rowStyle = theme => ({
      tableStriped:{
        '& tbody tr:nth-of-type(odd)':{
          //backgroundColor:this.props.selectedCssColorTheme.listRow.background,
          //color:this.props.selectedCssColorTheme.listRow.color
        },
        '& tbody tr:nth-of-type(even)':{
          //backgroundColor:this.props.selectedCssColorTheme.listRowNext.background,
          //color:this.props.selectedCssColorTheme.listRow.color
        },
        '& thead tr':{
          //backgroundColor:this.props.selectedCssColorTheme.trdbookHeader.background,
          ////color:this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        '& thead tr th':{
          //backgroundColor:this.props.selectedCssColorTheme.trdbookHeader.background,
          ////color:this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        '& .text-primary':{
          //color:this.props.selectedCssColorTheme.activeHeaderColor.color
        }
      },
    });

    const TableRow = props => {
      const { row } = props;
      if(row.deal === "BUY" || row.deal === "STOP BUY") {
        return <Table.Row {...props} className="blue" />;
      } else {
        return <Table.Row {...props} className="red" />;
      }
      return <Table.Row {...props} />;
    };

    const dropDownListColor =theme =>({
      dropDownListHoverMenu:{
        '& .dropdown-item':{
          // background:this.props.selectedCssColorTheme.dropDownList.background,
          // color:this.props.selectedCssColorTheme.dropDownList.color
        },
        '& :hover':{
          // background:this.props.selectedCssColorTheme.dropDownListHover.background,
          // color:this.props.selectedCssColorTheme.dropDownListHover.color
        }
      }
    });

    const ContainerColor = ({ classes, ...restProps }) => (
      <ColumnChooser.Container {...restProps} className={classes.dropDownListHoverMenu} />
    );

    const MenuColor = props => (
      <ColumnChooser.Item {...props} />
    );


    const TableComponentBase = ({ classes, ...restProps }) => (
      <Table.Table
        {...restProps}
        id="fixingOrdTable" className={classes.tableStriped}
      />
    );

    const searchPlaceholderMsg = {
      searchPlaceholder:(i18next.t('search'))+'...',
    };
    var NoDataMsg = {
      noData:'',
    }
    if (this.state.refreshIconFlag === true) {
      NoDataMsg.noData = '';
    }
    else {
      NoDataMsg.noData = (i18next.t('noDataAvlMsg'));
    }

    const NoDataCell = props => (
      <Table.NoDataCell {...props} className="noDataCell"  />
    );

    const cancelModalColumn=[
      {name:'orderNo', title:i18next.t('orderNo')},
      {name:'deal', title:i18next.t('deal')},
      {name:'cmdtyPair', title:i18next.t('cmdtyPair')},
      {name:'quantity', title:i18next.t('quantity')},
      {name:'qtyType', title:i18next.t('qtyType')},
      {name:'status_val', title:i18next.t('status')},
      {name:'reason', title:i18next.t('reason')}
    ];
    if(this.state.cancelFIXModel === true && this.props.requestRejectModal.OMT === 2) {
      if(this.props.requestRejectModal.title !== '' && this.props.requestRejectModal.OT === 4) {
        if(this.props.requestRejectModal.bcm === '107' || this.props.requestRejectModal.bcm === '106' || this.props.requestRejectModal.bcm === '111' || this.props.requestRejectModal.bcm === '308') {
          fixOrdRectFlag=true;
        }
      }
    }

    return (
      <div id="lmtOrderTbl" className={`${styles.trdbody} ${selectedfont_size} ${this.props.language}`}>
        {fixOrdRectFlag === true ?
          <Modal isOpen={fixOrdRectFlag === true} className={`${styles.warningModal}`} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.errorheader} errorheader`}>
                <span className={`${styles.errormsgTitle}`}>
                  {this.props.requestRejectModal.title}
                </span>
                <span className="modalCloseIcon" onClick={this.closeReqRejectModal}>{CloseIcon}</span>
              </div>
              <div className={`${styles.msgWrap} msgWrap commonMsgDir`}>
                <p>{i18next.t(this.props.requestRejectModal.msg)}</p>
              </div>
            </div>
          </Modal>
        : null}

        {this.state.disableModifyFlag === true ?
          <Modal isOpen={this.state.disableModifyFlag} id="fixOrdErrModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.errorheader} errorheader`}>
                <span className={`${styles.errormsgTitle}`}>{i18next.t(this.state.fixEditErrMsgHeader)}</span>
                <span className="modalCloseIcon" onClick={this.cancelDisableModifyModal}>{CloseIcon}</span>
              </div>
              <div className={`${styles.msgWrap} msgWrap commonMsgDir`}>
                <h4>{i18next.t(this.state.fixEditErrMsg)}</h4>
              </div>
              <div className={`${styles.btnWrap} col-md-12`}>
                <Button onClick={this.cancelDisableModifyModal} id="fixOrdCloseBtn" className='button-l lmtClose' bsStyle="primary">{i18next.t("OK")}</Button>
              </div>
            </div>
          </Modal>
        : null}

        {this.state.cancelAllDisableModal === true ?
          <Modal isOpen={this.state.cancelAllDisableModal} id="fixCancelAllOrdModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.errorheader} errorheader`}>
                <span className={`${styles.errormsgTitle}`}>{i18next.t(this.state.fixEditErrMsgHeader)}</span>
                <span className="modalCloseIcon" onClick={this.closeCancelAllDisableModal}>{CloseIcon}</span>
              </div>
              <div className={`${styles.msgWrap} msgWrap commonMsgDir`}>
                <h4>{i18next.t(this.state.fixEditErrMsg)}</h4>
                <ul className={styles.listWrap}>
                  {this.state.inactiveAccOnOrders.length && this.state.inactiveAccOnOrders.map(item => (
                    <li>{item.D} {`(${item.C})`}</li>
                  ))}
                </ul>
              </div>
              <div className={`${styles.btnWrap} col-md-12`}>
                <Button onClick={this.closeCancelAllDisableModal} id="fixOrdCloseBtn" className='button-l lmtClose' bsStyle="primary">{i18next.t("OK")}</Button>
              </div>
            </div>
          </Modal>
        : null}

        {this.props.fixModifyFlag === true && this.state.enableFixingModifyFlag === true ?
          <Modal isOpen={this.props.fixModifyFlag} id="modFixOrdModal" className={`${styles.FIXcontent}`} onAfterOpen={this.afterOpenModal}>
            {/*<div className={styles.header}>
              <p className={`${styles.msgTitle}`}>{i18next.t("Modify Fix Order")}</p>
              <span onClick={()=>this.closeFixingOrdpopup}>{closeIconImg}</span>
            </div>*/}
            <div ref="errorMSG" className="mdlWrap ModifyFixOrdrModal" >
              <ModifyFIXOrderComponent selectFixRow={this.state.orderSelection} />
            </div>
          </Modal>
        : null}

        {this.state.statusFlag === true ?
          <Modal isOpen={this.state.statusFlag} id="fixOrdCanStsModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.errorheader} errorheader`}>
                <span className={`${styles.errormsgTitle}`}>{i18next.t("error")}</span>
                <span className="modalCloseIcon" onClick={this.cancelStatusModal}>{CloseIcon}</span>
              </div>
              <div className={`${styles.msgWrap} msgWrap commonMsgDir`}>
                <h4>{i18next.t("noRatesMsg")}</h4>
              </div>
            </div>
          </Modal>
        : null}

        {this.state.cancelFIXModel === true ?
          <Modal isOpen={this.state.cancelFIXModel}id="fixOrdCanModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.errorheader} errorheader`}>
                {this.state.selectFIXKey === 'A' ? this.state.selectedDocNo === '' ?
                  <span className={`${styles.errormsgTitle}`}>{i18next.t("cancelOrd")}</span>
                :
                  <span className={`${styles.errormsgTitle}`}>{i18next.t("cancelOrd")}:{" "+ this.state.selectedDocNo}</span>
                : this.state.selectedOrderNo === '' ?
                  <span className={`${styles.errormsgTitle}`}>{i18next.t("cancelOrd")}</span>
                :
                  <span className={`${styles.errormsgTitle}`}>{i18next.t("cancelOrd")}:{" "+this.state.selectedOrderNo}</span>
                }
                <span className="modalCloseIcon" onClick={this.cancelFixCnfrmBox}>{CloseIcon}</span>
              </div>
              <div className={`${styles.msgWrap} msgWrap commonMsgDir`}>
                <h4>{i18next.t("cancelOrdConfrmMsg")}</h4>
              </div>
              <div className={this.props.language === 'AR' ? `${styles.btnWrap} col-md-3 cancelConfrmBtn` : `${styles.btnWrap} col-md-12`}>
                <Button onClick={this.cancelFixCnfrmBox} id="fixOrdCanBtn" className="lmtClose">{i18next.t("no")}</Button>&nbsp;&nbsp;
                {this.state.orderSelection.length === 1 ?
                <Button id="fixOrdCanSubBtn" className='button-l lmtClose' onClick={()=>this.cancelFIXOrder(this.state.orderSelection)}>{i18next.t("yes")}</Button>
                : <Button id="fixOrdCanSubBtn" className='button-l lmtClose' onClick={()=>this.multipleCancelFIXOrder(this.state.orderSelection)}>{i18next.t("yes")}</Button>}
              </div>
            </div>
          </Modal>
        : null}

        {this.state.multipleCancelModal === true ?
          <Modal isOpen={this.state.multipleCancelModal} id="fixOrdMulCanModal" className={`${styles.multiCancelOrdModal} ${this.props.language}`} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className="cancelOrdDiv">
                <div className={`${styles.errorheader} errorheader`}>
                  <span className={`${styles.errormsgTitle}`}>{i18next.t("cancelOrd")}</span>
                  <span className="modalCloseIcon" onClick={this.closeMultipleCancelModal}>{CloseIcon}</span>
                </div>

                <div id="fixMultiCancelTblDiv" className="cancelRowTblDiv">
                  <div className={`${styles.multipleCancelTable} ${OutstandingOrderHeader} ${selectedfont_size}`} id="mulCancelTbl">
                    <Card>
                      <Grid style={{height:'100%'}} rows={this.state.cancelModalrow} columns={cancelModalColumn} getRowId={getRowId}>
                        <DragDropProvider />
                        <SortingState onSortingChange={this.onChangeCancelModalSortiog} defaultSorting={[{columnName:'eventTime', direction:'desc'}]} id="lmtChngOutLmtColSorting" />
                        <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                        <SearchState value={this.state.cancelModalSearchValue} onValueChange={this.onChangeCancelModalSearchValue} id="lmtChngOutlmtSearchVal" />
                        <IntegratedFiltering />
                        <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)}
                          rowComponent={TableRow} height="auto" columnAutoWidth={true} columnExtensions={this.props.language === 'AR' ? this.state.cancelModalExtensionsAR : this.state.cancelModalExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} />
                        <TableColumnReordering order={this.state.cancelModalColOrder} onOrderChange={this.onChangeCancelModalColOrder} id="lmtChngOutLmtColOrd" />
                        <TableHeaderRow showSortingControls contentComponent={TableHeaderContent} />
                        <TableColumnVisibility />
                        <Toolbar />
                        <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
                      </Grid>
                    </Card>
                  </div>
                </div>

                <div className={`${styles.cancelOrdBtnDiv} col-md-12`}>
                  {parseInt(this.props.status) === 1 &&
                    <div className={`${styles.netDiscMsg}`}>{i18next.t('netDisconnectMsg')}</div>
                  }
                  {this.state.stopBtnReplaceflag === true ?
                    <div className={`${styles.btnWrap}`}>
                      <Button id="fixMulCanClsBtn" className='button-l lmtClose' onClick={this.closeBtnclick} bsStyle="primary">{i18next.t("close")}</Button>
                    </div>
                  :
                    <div className={`${styles.btnWrap}`}>
                      <Button id="fixMulCanStpBtn" className='button-l lmtClose'onClick={this.stopBtnclick} bsStyle="primary">{i18next.t("stop")}</Button>
                    </div>
                  }
                </div>
              </div>
            </div>
          </Modal>
        : null}

        {this.state.selectFIXKey === 'A' || this.state.selectFIXKey === 'O' ?
          <div className={`${styles.refresh_icon} refresh_icon`}>
            <span onClick={this.refreshComponentData} id="lmtRefreshCompData"><MUIIconWithTooltip icon={'Refresh'} style={this.props.selectedCssColorTheme.iconColor} className={`${styles.icon}`} title={i18next.t("refresh")}/></span>
            <span onClick={this.editFixingOrdModal} id="lmtEditOrdModal"><MUIIconWithTooltip icon={'Edit'} style={this.props.selectedCssColorTheme.iconColor} className={`${styles.icon}`} title={i18next.t("edit")}/></span>
            <span onClick={this.cancelFixOrdModal} id="lmtCancelOrd"><MUIIconWithTooltip icon={'Close'} style={this.props.selectedCssColorTheme.iconColor} className={`${styles.icon}`} title={i18next.t("cancel")}/></span>
          </div>
        :
          <div className={`${styles.refresh_icon} refresh_icon`}>
            <span onClick={this.refreshComponentData} id="lmtRefresh"><MUIIconWithTooltip icon={'Refresh'} style={this.props.selectedCssColorTheme.iconColor} className={`${styles.icon}`} title={i18next.t("refresh")}/></span>
          </div>
        }

        <div className={`${styles.orderRowsCount} orderRowsCount`}>
          <span className="trdbookText">{i18next.t("count")}</span>: <span>{this.state.fixOrdTableRowCount}</span>
        </div>

        <div id="fixOrdTypeList" className={`${styles.trade_filter} lmtOrderStatus ${this.props.selectedCssColor} ${this.props.language}`}>
          <ButtonToolbar>
            <DropdownButton title={i18next.t(this.state.selectFIX)} id="dropdown-size-small" className={`${styles.btnToolbar} ${selectedfont_size} lmtOrdDropdown btnText`}>
            <MenuItem eventKey="1" className={`${selectedfont_size}`} onClick={() => this.selectFIX("all", "A")} id="lmtselectAll">{i18next.t("all")}</MenuItem>
            <MenuItem eventKey="2" className={`${selectedfont_size}`} onClick={() => this.selectFIX("outstanding", "O")} id="lmtselectWorking">{i18next.t("outstanding")}</MenuItem>
            <MenuItem eventKey="3" className={`${selectedfont_size}`} onClick={() => this.selectFIX("filled", "F")} id="lmtselectFilled">{i18next.t("filled")}</MenuItem>
            <MenuItem eventKey="4" className={`${selectedfont_size}`} onClick={() => this.selectFIX("cancelled", "C")} id="lmtselectCancelled">{i18next.t("cancelled")}</MenuItem>
            </DropdownButton>
          </ButtonToolbar>
        </div>

        {this.state.selectFIXKey === 'A' ?
          <div className={`${styles.OutstandingOrderHeader} ${OutstandingOrderHeader} ${selectedfont_size} ${this.props.selectedCssColor}`} id="allLimitTbl" style={this.props.selectedLang.widgetwrapper}>
            <Card>
              <Grid style={{height:'100%'}} rows={this.state.allFixOrdersRows} columns={this.state.fixAllOrderColumnOrder} getRowId={getRowId}>
                <DragDropProvider />
                <SearchState value={this.state.allFixSearchValue} onValueChange={this.onChangeallFixSearchValue} id="lmtChngAllLmtSearchVal" />
                <SortingState onSortingChange={this.onChangeAllFixColSorting} defaultSorting={[{columnName:'eventTime', direction:'desc'}]} id="lmtChngAllLmtColSorting" />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                <IntegratedFiltering />
                <SelectionState selection={this.state.orderSelection} onSelectionChange={this.changeAllColSelection} />
                <PatchedIntegratedSelection rowSelectionEnabled={rowSelectionEnabled} />
                <Table cellComponent={AllOrdersCell} height="auto" columnAutoWidth={true} rowComponent={TableRow}
                tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} columnExtensions={this.props.language === 'AR' ? this.state.fixAllOrderColumnOrderExtensionsAR : this.state.fixAllOrderColumnOrderExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} />
                <TableColumnReordering order={this.state.fixAllOrderColumnOrder} onOrderChange={this.onChangeAllLmtColOrder} id="lmtChngAllLmtColOrd" />
                <TableHeaderRow showSortingControls contentComponent={TableHeaderContent} />
                <PatchedTableSelection rowSelectionEnabled={rowSelectionEnabled} showSelectAll />
                <TableColumnVisibility columnExtensions={this.state.colVisibilityExtensions} hiddenColumnNames={this.state.fixAllOrderColumnOrder} onHiddenColumnNamesChange={this.onChangeHiddenAllFixCol} id="lmtChngHiddenAlllmtCol" />
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} />
                <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </Card>
          </div>
        : null}

        {this.state.selectFIXKey === 'O' ?
          <div className={`${styles.OutstandingOrderHeader} ${OutstandingOrderHeader} ${selectedfont_size} ${this.props.selectedCssColor}`} id="outLimitTbl" style={this.props.selectedLang.widgetwrapper}>
            <Card>
              <Grid style={{height:'100%'}} rows={this.state.outstngFixOrderRows} columns={this.state.outFixOrdcolumns} getRowId={getRowId}>
                <DragDropProvider />
                <SortingState onSortingChange={this.onChangeOutFixColSorting} defaultSorting={[{columnName:'eventTime', direction:'desc'}]} id="lmtChngOutLmtColSorting" />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                <SearchState value={this.state.outFixSearchValue} onValueChange={this.onChangeOutFixSearchValue} id="lmtChngOutlmtSearchVal" />
                <IntegratedFiltering />
                <SelectionState selection={this.state.orderSelection} onSelectionChange={this.changeOutColSelection} />
                <IntegratedSelection />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} height="auto" columnAutoWidth={true} rowComponent={TableRow} columnExtensions={this.props.language === 'AR' ? this.state.outFixOrdColumnExtensionsAR : this.state.outFixOrdColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} cellComponent={Cell} />
                <TableColumnReordering order={this.state.fixOutStandingOrderColumnOrder} onOrderChange={this.onChangeOutFixColOrder} id="lmtChngOutLmtColOrd" />
                <TableHeaderRow showSortingControls contentComponent={TableHeaderContent} />
                <TableSelection showSelectAll />
                <TableColumnVisibility columnExtensions={this.state.colVisibilityExtensions} hiddenColumnNames={this.state.hiddenFixOutStandingOrderColumnNames} onHiddenColumnNamesChange={this.onChangeHiddenOutFixCol} id="lmtChngHiddenAllLmtColmn" />
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} />
                <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </Card>
          </div>
        : null}

        {this.state.selectFIXKey === 'F' ?
          <div className={`${styles.OutstandingOrderHeader} ${OutstandingOrderHeader} ${selectedfont_size} ${this.props.selectedCssColor}`} id="FilledLimitTbl" style={this.props.selectedLang.widgetwrapper}>
            <Card>
              <Grid style={{height:'100%'}} rows={this.state.fixOrderFilledrows} columns={this.state.fixFilledOrderColumnOrder}>
                <DragDropProvider />
                <SortingState onSortingChange={this.onChangeFillColSorting} defaultSorting={[{columnName:'eventTime', direction:'desc'}]} id="lmtChngFillColSort" />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                <SearchState value={this.state.filledFixSearchValue} onValueChange={this.onChangeFilledSearchValue} id="lmtChngFillSearchVal" />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} rowComponent={TableRow} height="auto" columnAutoWidth={true} columnExtensions={this.props.language === 'AR' ? this.state.fixFilledOrderColumnOrderExtensionsAR : this.state.fixFilledOrderColumnOrderExtensions} cellComponent={FillOrdersCell} messages={NoDataMsg} noDataCellComponent={NoDataCell} />
                <TableColumnReordering order={this.state.fixFilledOrderColumnOrder} onOrderChange={this.onChangefixFilledOrderColumnOrder} id="lmtChngFilledLmtColOrd" />
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility hiddenColumnNames={this.state.hiddenFixFilledOrderColumnNames} onHiddenColumnNamesChange={this.onChangeHiddenFilledCol} id="lmtChngHiddenFilledCol" />
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} />
                <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </Card>
          </div>
        : null}

        {this.state.selectFIXKey === 'C' ?
          <div className={`${styles.OutstandingOrderHeader} ${OutstandingOrderHeader} ${selectedfont_size} ${this.props.selectedCssColor}`} id="cancelledLimitTbl" style={this.props.selectedLang.widgetwrapper}>
            <Card>
              <Grid style={{height:'100%'}} rows={this.state.fixCancelledOrderRows} columns={this.state.fixCancelledOrderColumnOrder}>
                <DragDropProvider />
                <SortingState onSortingChange={this.onChangeCancelColSorting} defaultSorting={[{columnName:'eventTime', direction:'desc'}]} id="lmtChngCancelColSort" />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                <SearchState value={this.state.cancelledFixSearchValue} onValueChange={this.onChangeCancelSearchValue} id="lmtChngCancelSearchVal" />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} height="auto" rowComponent={TableRow} columnAutoWidth={true} columnExtensions={this.props.language === 'AR' ? this.state.fixCancelledOrderColumnOrderExtensionsAR : this.state.fixCancelledOrderColumnOrderExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} cellComponent={Cell} />
                <TableColumnReordering order={this.state.fixCancelledOrderColumnOrder} onOrderChange={this.onChangeCancelColOrder} id="lmtChngCancelColOrd" />
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility hiddenColumnNames={this.state.hiddenFixCancelledOrderColumnNames} onHiddenColumnNamesChange={this.onChangeHiddenCancelCol} id="lmtChngHiddenCancelCol" />
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} />
                <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </Card>
          </div>
        : null}


        {this.state.refreshIconFlag === true ?
          <div id="overlay" >
            <i className="fa fa-spinner fa-spin spin-big"></i>
          </div>
        : null}
      </div>
    );
  }
}
